module.exports = __webpack_public_path__ + "img/s-hd.7cd7e59c.jpg";